import React from 'react';
// import * as paymentMethods from 'data/followup/constants/payment_methods';
import cx from 'classnames';
import {NavBar} from "../../shared/components/NavBar";
// import SummaryContainer from "ui/followup/containers/SummaryContainer";
// import Documents from "ui/followup/components/Documents";

const PayForm = ({ isFetching, method, onChooseMethod, children, tabs }) => (
    <div>
        <NavBar tabs={tabs} currentTab={method} onClick={onChooseMethod}/>
        {!isFetching && children}
    </div>

);

export default PayForm;
